import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface CanvasContextType {
  isCanvasVisible: boolean;
  setCanvasVisible: (visible: boolean) => void;
  shouldRenderCanvas: boolean;
  isScrolled: boolean;
}

const CanvasContext = createContext<CanvasContextType | null>(null);

export const CanvasProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCanvasVisible, setCanvasVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const shouldRenderCanvas = isCanvasVisible && !isScrolled && isHomePage;

  return (
    <CanvasContext.Provider value={{ 
      isCanvasVisible, 
      setCanvasVisible, 
      shouldRenderCanvas,
      isScrolled 
    }}>
      {children}
    </CanvasContext.Provider>
  );
};

export const useCanvas = () => {
  const context = useContext(CanvasContext);
  if (!context) {
    throw new Error('useCanvas must be used within a CanvasProvider');
  }
  return context;
};
